import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { ISimplesTabela } from "../../model";

export const DefaultSelect = Select.ofType<ISimplesTabela>();

export const filterItens: ItemPredicate<ISimplesTabela> = (query, item) => {
  return item.descricao.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderItens: ItemRenderer<ISimplesTabela> = (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={item.cod}
      text={item.descricao}
      onClick={handleClick}
    />
  );
};
